import React from "react";
import PartyReport from "../PartyReport";


export default function ReportParty({ sessionObject }) {
  // if (!sessionObject.sessionVariables["modules"].includes("report-party")) {
  //   return;
  // }
  return (
    <div className="page-bilty">
      <PartyReport sessionObject={sessionObject} />
    </div>
  );
}
